import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M6.3 2.5h5.9c1.8 0 2.8 0 3.5.4.6.3 1.1.8 1.4 1.4.4.7.4 1.7.4 3.5v6M5.2 17.4h6.7c1 0 1.4 0 1.8-.2.3-.1.5-.4.7-.7.2-.4.2-.8.2-1.8V8.1c0-1 0-1.4-.2-1.8a1.7 1.7 0 0 0-.7-.7c-.4-.2-.8-.2-1.8-.2H5.2c-1 0-1.4 0-1.8.2-.3.2-.6.4-.7.7-.2.4-.2.9-.2 1.8v6.7c0 1 0 1.4.2 1.8.1.3.4.6.7.7.4.2.8.2 1.8.2z"
    }, null, -1)
  ]))]))
}
export default { render: render }